import React, { useState } from "react";
import { Box } from "@mui/material";
import { Chip } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles(() => ({
  tableChip: {
    backgroundColor: "#F9FAFB",
    border: "1px solid #D1D5DC",
  },
  darkChip: {
    backgroundColor: "#222",
    color: "#fff",
    cursor: "pointer",
    border: "none",
    "&&:hover": {
      backgroundColor: "#444",
    },
    "&&:focus": {
      backgroundColor: "#222",
    }
  }
}));

const ClickableAliasChips = ({ item }) => {
  const classes = useStyles();
  const [isExpanded, setIsExpanded] = useState(false);

  if (!item) return "-";
  
  const items = Array.isArray(item)
    ? item
    : typeof item === "string"
    ? item.split(",").map(s => s.trim()).filter(Boolean)
    : [item];
    
  if (items.length === 0) return "-";
  
  const maxItems = 2;
  const visibleItems = items.slice(0, maxItems);
  const hiddenItems = items.slice(maxItems);

  if (hiddenItems.length === 0) {
    return (
      <Box display="flex" flexWrap="wrap" gap={1}>
        {items.map((val, i) => (
          <Chip 
            key={i} 
            label={val} 
            size="small" 
            variant="outlined" 
            className={classes.tableChip}
          />
        ))}
      </Box>
    );
  }

  return (
    <Box display="flex" flexWrap="wrap" gap={1}>
      {(!isExpanded ? visibleItems : items).map((val, i) => (
        <Chip 
          key={i} 
          label={val} 
          size="small" 
          variant="outlined" 
          className={classes.tableChip}
        />
      ))}
      {!isExpanded ? (
        <Chip
          label={`+${hiddenItems.length}`}
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            setIsExpanded(true);
          }}
          className={classes.darkChip}
        />
      ) : (
        <Chip
          label="Show less"
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            setIsExpanded(false);
          }}
          className={classes.darkChip}
        />
      )}
    </Box>
  );
};

export default ClickableAliasChips;
